import { faAngleRight, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import { useDispatch, useSelector } from "react-redux";
import { GetAllBanks, SetSelectedBank } from "../../../features/wallet/slice";
import { maskAccountNumber } from "../../../utils/common";

function Bank_Card_Content() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signin } = useContext(Context);

  const selectedBank = useSelector((state) => state.wallet.selectedBank);
  const allBanks = useSelector((state) => state.wallet.banks);

  const bank = selectedBank?.bank_name
    ? selectedBank
    : allBanks?.find((b) => b.id === selectedBank?.id) || null;

  useEffect(() => {
    if (signin) dispatch(GetAllBanks({}));
  }, [dispatch, signin]);

  useEffect(() => {
    if (allBanks?.length === 0) {
      localStorage.removeItem("selected_bank_id");
    }
  }, [allBanks]);

  return (
    <section className="Bank_Card_Content">
      <section className="Withdraw_bank_info">
        <div className="bank_row" onClick={() => navigate("/bank-account")}>
          <div className="row align-items-center">

            {/* Bank Icon */}
            <div className="col-4">
              <div className="bank_left">
                <div className="bank_icon">
                  <img
                    src="/assets/images/withdraw_Deposite/Payment_Method_Cards/bank.png"
                    className="bank_img"
                    alt="bank img"
                  />
                  {bank?.bank_name && (
                    <p className="bank_name">{bank?.bank_name}</p>
                  )}
                </div>
              </div>
            </div>

            {/* Account number or warning */}
            <div className="col-6">
              <div className="bank_right">
                {bank?.account_number ? (
                  // Bank selected — show masked number
                  <span>{maskAccountNumber(bank?.account_number)}</span>
                ) : (
                  // No bank selected — show warning
                  <span style={{ color: "#fc5c5d", fontSize: "13px" }}>
                    ⚠ No bank selected.{" "}

                  </span>
                )}
              </div>
            </div>

            {/* Arrow */}
            <div className="col-2">
              <div className="bank_right">
                <FontAwesomeIcon icon={bank ? faAngleRight : faPlus} />
              </div>
            </div>

          </div>
        </div>
      </section>
    </section>
  );
}

export default Bank_Card_Content;